import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, House } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="brand-hero min-h-[70vh] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="font-heading font-black text-[8rem] leading-none tracking-tighter brand-hero-highlight">
          404
        </div>
        <h1 className="font-heading font-extrabold text-white text-3xl tracking-tight mt-2 mb-3">
          Page not found
        </h1>
        <p className="text-white/85 mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full brand-hero-primary text-sm font-bold transition-colors"
          >
            <House size={16} weight="bold" /> Back to home
          </Link>
          <Link
            to="/services"
            data-testid="notfound-services-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full brand-hero-secondary border text-sm font-semibold transition-colors"
          >
            <ArrowLeft size={16} weight="bold" /> Browse services
          </Link>
        </div>
      </div>
    </div>
  );
}
